export default {
  none: 'none',
  bounce: 'vui-bounce 1s infinite',
  fadeDown: 'vui-fadeDown 0.2s ease-in-out',
  fadeIn: 'vui-fadeIn 0.2s ease-in-out',
  fadeLeft: 'vui-fadeLeft 0.2s ease-in-out',
  fadeLeftLong: 'vui-fadeLeftLong 0.3s ease-out',
  fadeOut: 'vui-fadeOut 0.2s ease-in-out',
  fadeRight: 'vui-fadeRight 0.2s ease-in-out',
  fadeRightLong: 'vui-fadeRightLong 0.3s ease-out',
  fadeUp: 'vui-fadeUp 0.2s ease-in-out',
  pulse: 'vui-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
  spin: 'vui-spin 1s linear infinite',
}
